export const POPULATE_DESCRIPTIONS = 'POPULATE_DESCRIPTIONS';
export const POPULATE_CLASSIFICATION = 'POPULATE_CLASSIFICATION';
export const VALUE_FILE = 'file';
